export const PAGE_ROUTE = {
    DASHBOARD: '/dashboard',
}